"use client"

import { EventCarouselContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/EventCarousel/components/EventCarouselContent"
import { HeroBannerWithBreadcrumbContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeroBannerWithBreadcrumb/components/HeroBannerWithBreadcrumbContent"
import { t } from "@/languages/i18n"
import { DefaultImage } from "@/lib/external-components"
import { toImageSrc } from "@/lib/utils"
import { getEventBySlug } from "@/services/event-services"
import { EventData } from "@/types/event"
import { useParams } from "next/navigation"
import { useCallback, useEffect, useState } from "react"
import { EventDetailContent } from "./components/EventDetailContent"
import { EventErrorState } from "./components/EventErrorState"
import { EventInfoSidebar } from "./components/EventInfoSidebar"
import { EventLoadingState } from "./components/EventLoadingState"

export default function EventDetailPageClient() {
  const params = useParams()
  const slug = params?.slug as string
  const [event, setEvent] = useState<EventData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchEventData = useCallback(async () => {
    if (!slug) {
      setError("Event ID not found")
      setLoading(false)
      return
    }

    try {
      setLoading(true)
      setError(null)
      const eventData = await getEventBySlug(slug)
      setEvent(eventData)
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load event")
    } finally {
      setLoading(false)
    }
  }, [slug])

  useEffect(() => {
    fetchEventData()
  }, [fetchEventData])

  if (loading) {
    return <EventLoadingState />
  }

  if (error || !event) {
    return <EventErrorState error={error} />
  }


  return (
    <>
      <HeroBannerWithBreadcrumbContent
        id="event-detail-hero-banner"
        breadcrumb={[
          { title: t("Homepage"), link: "/" },
          { title: t("Events"), link: "/event" },
        ]}
        image={toImageSrc(event?.attributes?.cover?.data?.attributes?.url) || DefaultImage}
        title={event.attributes.name || ""}
        isTamdaOne={true}
      />
      <div className="w-full max-w-[1304px] mx-auto sm:px-2 px-4 sm:pt-[50px] pt-4 sm:pb-10 pb-8">
        <div className="flex sm:flex-row flex-col sm:gap-[80px] gap-4">
          <EventDetailContent event={event} />
          <EventInfoSidebar event={event} />
        </div>
      </div>
      <EventCarouselContent
        title={t("UPCOMING EVENTS")}
        viewAllUrl="/event"
        contentClassName="sm:pt-0 pt-0 pb-[60px]"
      />
    </>
  )
}
